function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { useMemo } from "react";
import { useBuildStyleWithTheme } from "../ThemeProvider/useBuildStyleWithTheme";
var buildStyle = function(theme) {
    var animation = theme.animation, borderColor = theme.borderColor, font = theme.font, spacing = theme.spacing, size = theme.size;
    return {
        fieldset: {
            base: {
                borderWidth: "".concat(size.border.base, "px"),
                borderStyle: 'solid',
                borderColor: borderColor.base,
                borderRadius: size.border.radius.threeX,
                background: 'transparent',
                position: 'absolute',
                top: '-10px',
                padding: 0,
                margin: 0,
                boxSizing: 'border-box',
                overflow: 'hidden',
                pointerEvents: 'none',
                height: 'calc(100% + 10px)',
                width: '100%'
            },
            variant: {
                default: {
                    top: '-10px'
                },
                underline: {
                    borderRadius: 0,
                    borderWidth: "0 0 ".concat(size.border.base, "px 0")
                },
                grid: {
                    borderRadius: 0,
                    borderStyle: 'dashed',
                    borderWidth: "0 0 ".concat(size.border.base, "px 0"),
                    height: '100%',
                    top: 0
                },
                outline: {}
            },
            hasError: {
                borderColor: borderColor.danger.base
            },
            hasLabel: {
                variant: {
                    default: {
                        top: '15px'
                    },
                    underline: {},
                    grid: {},
                    outline: {}
                }
            },
            isDisabled: {
                borderColor: borderColor.disabled
            },
            size: {
                variant: {
                    default: {
                        s: {
                            fontSize: font.base.size[3],
                            height: '46px',
                            padding: "0 ".concat(spacing[4])
                        },
                        m: {
                            height: '50px'
                        }
                    },
                    underline: {
                        s: {},
                        m: {}
                    },
                    grid: {
                        s: {},
                        m: {}
                    },
                    outline: {
                        s: {},
                        m: {}
                    }
                }
            }
        },
        legend: {
            base: {
                display: 'block',
                fontFamily: font.base.family,
                fontSize: font.base.size[3],
                fontStyle: 'normal',
                fontWeight: font.base.weight.regular,
                height: '19.5px',
                letterSpacing: 'normal',
                lineHeight: '19.5px',
                margin: "0 ".concat(spacing[4]),
                padding: 0,
                transitionDuration: animation.duration[100],
                transitionProperty: 'width',
                visibility: 'hidden',
                width: 0
            },
            isAnimated: {
                padding: "0 ".concat(spacing[2]),
                width: 'unset'
            },
            isRequired: {
                margin: 0,
                padding: 0
            },
            isAnimatedAndRequired: {
                margin: "0 ".concat(spacing[2]),
                padding: "0 ".concat(spacing[2], " 0 ").concat(spacing[4])
            }
        }
    };
};
export var useStyle = function(param) {
    var _hasActiveLabelTransition = param.hasActiveLabelTransition, hasActiveLabelTransition = _hasActiveLabelTransition === void 0 ? false : _hasActiveLabelTransition, _hasError = param.hasError, hasError = _hasError === void 0 ? false : _hasError, _hasLabel = param.hasLabel, hasLabel = _hasLabel === void 0 ? true : _hasLabel, height = param.height, _isDisabled = param.isDisabled, isDisabled = _isDisabled === void 0 ? false : _isDisabled, _isRequired = param.isRequired, isRequired = _isRequired === void 0 ? false : _isRequired, _size = param.size, size = _size === void 0 ? 'm' : _size, _variant = param.variant, variant = _variant === void 0 ? 'default' : _variant;
    var ref7;
    var ref1 = (ref7 = useBuildStyleWithTheme(buildStyle)) !== null && ref7 !== void 0 ? ref7 : {}, fieldset = ref1.fieldset, legend = ref1.legend;
    return useMemo(function() {
        var ref, ref2, ref3, ref4, ref5, ref6;
        return {
            fieldset: _objectSpread({}, fieldset === null || fieldset === void 0 ? void 0 : fieldset.base, fieldset === null || fieldset === void 0 ? void 0 : (ref = fieldset.variant) === null || ref === void 0 ? void 0 : ref[variant], fieldset === null || fieldset === void 0 ? void 0 : (ref2 = fieldset.size) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.variant) === null || ref3 === void 0 ? void 0 : (ref4 = ref3[variant]) === null || ref4 === void 0 ? void 0 : ref4[size], hasLabel && (fieldset === null || fieldset === void 0 ? void 0 : (ref5 = fieldset.hasLabel) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.variant) === null || ref6 === void 0 ? void 0 : ref6[variant]), hasError && (fieldset === null || fieldset === void 0 ? void 0 : fieldset.hasError), isDisabled && (fieldset === null || fieldset === void 0 ? void 0 : fieldset.isDisabled), height && {
                height: "".concat(height + (variant === 'grid' ? 0 : 10), "px")
            }),
            legend: _objectSpread({}, legend === null || legend === void 0 ? void 0 : legend.base, hasLabel && isRequired && (legend === null || legend === void 0 ? void 0 : legend.isRequired), hasLabel && hasActiveLabelTransition && (legend === null || legend === void 0 ? void 0 : legend.isAnimated), hasLabel && isRequired && hasActiveLabelTransition && (legend === null || legend === void 0 ? void 0 : legend.isAnimatedAndRequired))
        };
    }, [
        fieldset,
        hasActiveLabelTransition,
        hasError,
        hasLabel,
        height,
        isDisabled,
        isRequired,
        legend,
        size,
        variant
    ]);
};
export default useStyle;
